import { SET_MENU_CARD_COPY_TASKS, SET_MENU_CARD_UPDATED_AT } from '../../actionTypes/menuCardCopyTask'

export const setMenuCardCopyTasks = value => ({ type: SET_MENU_CARD_COPY_TASKS, value })

export const setMenuCardUpdatedAt = value => ({ type: SET_MENU_CARD_UPDATED_AT, value })
